module.exports = __webpack_public_path__ + "static/media/appwork_3.3deb81a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/appwork_3.png
// module id = 482
// module chunks = 0